export type HealthcareProviderType = 'HEALTHCARE_PRACTICE' | 'HEALTHCARE_ORGANIZATION';

export const HEALTHCARE_PRACTICE_PATH = '/moja-praktyka';
export const HEALTHCARE_ORGANIZATION_PATH = '/moj-podmiot';

const AI_ASSISTANT_NAV_PARAM = 'asystent-wizyty';

export const getHealthcareProviderPath = (healthcareProviderType: HealthcareProviderType): string =>
   healthcareProviderType === 'HEALTHCARE_ORGANIZATION' ? HEALTHCARE_ORGANIZATION_PATH : HEALTHCARE_PRACTICE_PATH;

export const getAiAssistantSettingsPath = (healthcareProviderType: HealthcareProviderType): string =>
   `${getHealthcareProviderPath(healthcareProviderType)}/${AI_ASSISTANT_NAV_PARAM}`;
